export default "__VITE_ASSET__6bc34720__"